export default "<ng-katex-paragraph [paragraph]=\"paragraph\"></ng-katex-paragraph>"